import { memo } from 'react'

import { Offer } from '@wwt/entities/search-response'

import { PricePopoverOrDialog } from './PricePopoverOrDialog'
import { PriceWithIcon } from './PriceWithIcon'

interface CellPriceProps {
	offer: Offer
}

export const CellPrice = memo(({ offer }: CellPriceProps) => {
	const totalPrice = offer.price.totalPrice(true)

	return (
		<PricePopoverOrDialog offer={offer}>
			{/* TODO: merge styles with dev */}
			<PriceWithIcon
				price={totalPrice}
				className="outline-primary ts-7 sm:ts-5 -outline-offset-1 hover:outline data-[state=open]:outline md:justify-center"
			/>
		</PricePopoverOrDialog>
	)
})

CellPrice.displayName = 'CellPrice'
